var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oldmanmap"},[_c('div',{ref:"amap",staticClass:"map",attrs:{"id":"container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }